'use client';

import { Button } from '@module/mdrt-org/shared/components';
import { ErrorPageContentBase } from '@module/mdrt-org/shared/components/error-page-content-base/error-page-content-base';
import { useRouter } from '@module/mdrt-org/shared/i18n';
import { ButtonVariant } from '@shared/ui-components';

export const MemberNotFoundPageContent = ({
  cmsContent,
}: {
  cmsContent: { backButtonInErrorPageLabel: string; notFoundMessage: string };
}) => {
  const router = useRouter();

  return (
    <ErrorPageContentBase
      actionsSlot={
        <Button onClick={() => router.back()} variant={ButtonVariant.Secondary}>
          {cmsContent.backButtonInErrorPageLabel}
        </Button>
      }
      message={cmsContent.notFoundMessage}
    />
  );
};
